import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="unauthorized-container">
      <div class="unauthorized-content">
      <h1>Access Denied</h1>
      <p>You are not authorized to access this page.</p>
      <button (click)="goToHome()" class="btn-primary">Go Back</button>
      </div>
    </div>
  `,
  styles: [`
    .unauthorized-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background-color: #f5f5f5;
      padding: 1rem;
    }
    .unauthorized-content {
      text-align: center;
      padding: 2rem;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      max-width: 500px;
      width: 100%;
    }
    h1 {
      color: #d32f2f;
      margin-bottom: 1rem;
      font-size: 2rem;
    }
    p {
      color: #666;
      margin-bottom: 2rem;
      font-size: 1.1rem;
    }
    .btn-primary {
      padding: 0.75rem 1.5rem;
      background-color: #1976d2;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 1rem;
      transition: background-color 0.2s;
    }
    .btn-primary:hover {
      background-color: #1565c0;
    }
    .btn-primary:active {
      background-color: #0d47a1;
    }
  `]
})
export class UnauthorizedComponent {
  constructor(private readonly router: Router) {}
  
  goToHome(): void {
    const persona = localStorage.getItem('persona')?.toLowerCase() || '';
    let homeRoute = '/profile';
    
    // Map persona to home route
    if (persona.includes('admin')) homeRoute = '/admin';
    else if (persona.includes('grower')) homeRoute = '/growers';
    else if (persona.includes('transload')) homeRoute = '/transloading';
    else if (persona.includes('receiver')) homeRoute = '/receiver';
    else if (persona.includes('shunt')) homeRoute = '/shunting';
    else if (persona.includes('schedule')) homeRoute = '/scheduler';
    else if (persona.includes('gate')) homeRoute = '/gatehouse';
    
    this.router.navigate([homeRoute]);
  }
}

